import { useId } from "react";

import { FigureFrame } from "./FigureFrame";
import type { ResearchFigureProps } from "./types";

const ink = "var(--figure-ink, currentColor)";
const accent = "var(--figure-accent, currentColor)";
const surface = "var(--figure-surface, transparent)";

export function XrFigure({
  className,
  caption,
  title = "Foreign beauty brands and extended-reality campaigns",
  description = "A study of 257 beauty brands and 375,477 brand-day observations in South Korea from 2019 to 2022 examines foreignness disadvantage, campaign design, and mitigating conditions.",
}: ResearchFigureProps) {
  const markerId = `xr-arrow-${useId().replace(/:/g, "")}`;

  return (
    <FigureFrame
      className={className}
      caption={caption}
      title={title}
      description={description}
      viewBox="0 0 760 470"
    >
      <defs>
        <marker
          id={markerId}
          viewBox="0 0 10 10"
          refX="9"
          refY="5"
          markerWidth="6"
          markerHeight="6"
          orient="auto"
        >
          <path d="M 0 0 L 10 5 L 0 10 z" fill={accent} />
        </marker>
      </defs>

      <text x="32" y="36" fill={ink} fontSize="12" fontWeight="650" letterSpacing="1.45">
        257 BRANDS · 375,477 BRAND-DAY OBSERVATIONS · KOREA, 2019–2022
      </text>
      <line x1="32" y1="54" x2="728" y2="54" stroke={ink} strokeWidth="1.25" />

      <g fill={surface} stroke={ink} strokeWidth="1.25">
        <rect x="32" y="98" width="206" height="86" />
        <rect x="520" y="98" width="208" height="86" />
      </g>
      <text x="135" y="132" fill={ink} fontSize="18" fontWeight="650" textAnchor="middle">
        Foreignness
      </text>
      <text x="135" y="157" fill={ink} fontSize="13" textAnchor="middle">
        foreign beauty brand
      </text>
      <text x="624" y="132" fill={ink} fontSize="18" fontWeight="650" textAnchor="middle">
        Campaign response
      </text>
      <text x="624" y="157" fill={accent} fontSize="13" fontWeight="700" textAnchor="middle">
        disadvantage
      </text>
      <path
        d="M 254 141 H 504"
        fill="none"
        stroke={accent}
        strokeWidth="1.5"
        markerEnd={`url(#${markerId})`}
      />

      <g transform="translate(32 244)">
        <text x="0" y="0" fill={ink} fontSize="12" fontWeight="650" letterSpacing="1.6">
          CAMPAIGN DESIGN
        </text>
        <line x1="0" y1="18" x2="696" y2="18" stroke={ink} strokeWidth="1.25" />

        <g fill={ink} fontSize="15">
          <text x="0" y="60">Lower realism</text>
          <text x="232" y="60">Higher interactivity</text>
          <text x="476" y="60">Higher vividness</text>
        </g>
        <line x1="0" y1="81" x2="696" y2="81" stroke={ink} strokeOpacity=".18" />
        <text x="0" y="119" fill={accent} fontSize="15" fontWeight="700">
          each intensifies the disadvantage
        </text>

        <line x1="0" y1="151" x2="696" y2="151" stroke={ink} strokeOpacity=".25" />
        <text x="0" y="188" fill={ink} fontSize="12" fontWeight="650" letterSpacing="1.6">
          MITIGATORS
        </text>
        <text x="180" y="188" fill={ink} fontSize="15">
          Brand newness
        </text>
        <text x="375" y="188" fill={ink} fontSize="15">
          Multiple platforms
        </text>
        <text x="696" y="188" fill={accent} fontSize="15" fontWeight="700" textAnchor="end">
          reduce
        </text>
      </g>
    </FigureFrame>
  );
}
